/**
 *
 */
export type LogLevels = "trace" | "debug" | "info" | "warn" | "error";

/**
 *
 */
/*                               */
export const logLevels = ["trace", "debug", "info", "warn", "error"] as const satisfies LogLevels[];

/**
 *
 */
export const Level = Object.fromEntries(logLevels.map((k) => [k, k])) as { [P in LogLevels]: P };
